import { TEMPLATE_TYPES, TEMPLATES } from "utils/constants";
import AdherentBirthDate from "./AdherenBirthdate";
import AdherentInfo from "./AdherentInfo";
import AdherentTelecoms from "./AdherentTelecoms";
import BankInformation from "./BankInformation";
import ChildrenJustification from "./ChildrenJustification";
import Loading from "./Components/Loader";
import ContactAdvisor from "./ContactAdvisor";
import ContactSuccess from "./ContactSuccess";
import Default from "./Default";
import EffectiveDate from "./EffectiveDate";
import ElectronicSignature from "./ESign";
import GenerateESignDocuments from "./GenerateESignDocuments";
import Justification from "./Justification";
import Needs from "./Needs";
import Packs from "./Packs";
import Payment from "./Payment";
import Products from "./Products";
import Profile from "./Profile";
import RelatedPersons from "./RelatedPersons";
import SocialSecurityNumber from "./SocialSecurityNumber";
import SpouseJustification from "./SpouseJustification";
import SubscriptionDone from "./SubscriptionDone";
import Upsells from "./Upsells";
import ElectronicSignatureYousign from "./ESignYousign";

const Templates = {
  Loading: <Loading />,
  [TEMPLATES.B2C.THEMES[TEMPLATE_TYPES.B2C_ACORIS].PROFILE]: Profile,
  [TEMPLATES.B2C.THEMES[TEMPLATE_TYPES.B2C_ACORIS].ADHERENT_BIRTHDATE]:
    AdherentBirthDate,
  [TEMPLATES.B2C.THEMES[TEMPLATE_TYPES.B2C_ACORIS].CONTACT_ADVISOR]:
    ContactAdvisor,
  [TEMPLATES.B2C.THEMES[TEMPLATE_TYPES.B2C_ACORIS].CONTACT_SUCCESS]:
    ContactSuccess,
  [TEMPLATES.B2C.THEMES[TEMPLATE_TYPES.B2C_ACORIS].NEEDS]: Needs,
  [TEMPLATES.B2C.THEMES[TEMPLATE_TYPES.B2C_ACORIS].ADHERENT_INFO]: AdherentInfo,
  [TEMPLATES.B2C.THEMES[TEMPLATE_TYPES.B2C_ACORIS].PRODUCTS]: Products,
  [TEMPLATES.B2C.THEMES[TEMPLATE_TYPES.B2C_ACORIS].EFFECTIVE_DATE]:
    EffectiveDate,
  [TEMPLATES.B2C.THEMES[TEMPLATE_TYPES.B2C_ACORIS].ADHERENT_TELECOMS]:
    AdherentTelecoms,
  [TEMPLATES.B2C.THEMES[TEMPLATE_TYPES.B2C_ACORIS]
    .ADHERENT_SOCIAL_SECURITY_NUMBER]: SocialSecurityNumber,
  [TEMPLATES.B2C.THEMES[TEMPLATE_TYPES.B2C_ACORIS].RELATED_PERSONS]:
    RelatedPersons,
  [TEMPLATES.B2C.THEMES[TEMPLATE_TYPES.B2C_ACORIS].ADHERENT_BANK_INFORMATION]:
    BankInformation,
  [TEMPLATES.B2C.THEMES[TEMPLATE_TYPES.B2C_ACORIS].PAYMENT]: Payment,
  [TEMPLATES.B2C.THEMES[TEMPLATE_TYPES.B2C_ACORIS].GENERATE_E_SIGN_DOCUMENTS]:
    GenerateESignDocuments,
  [TEMPLATES.B2C.THEMES[TEMPLATE_TYPES.B2C_ACORIS].E_SIGN]: ElectronicSignature,
  [TEMPLATES.B2C.THEMES[TEMPLATE_TYPES.B2C_ACORIS].E_SIGN_YOUSIGN]: ElectronicSignatureYousign,
  [TEMPLATES.B2C.THEMES[TEMPLATE_TYPES.B2C_ACORIS].JUSTIFICATIONS]:
    Justification,
  [TEMPLATES.B2C.THEMES[TEMPLATE_TYPES.B2C_ACORIS].JUSTIFICATIONS_AFTER_SIGN]:
    Justification,
  [TEMPLATES.B2C.THEMES[TEMPLATE_TYPES.B2C_ACORIS].SPOUSE_JUSTIFICATIONS]:
    SpouseJustification,
  [TEMPLATES.B2C.THEMES[TEMPLATE_TYPES.B2C_ACORIS].CHILDREN_JUSTIFICATIONS]:
    ChildrenJustification,
  [TEMPLATES.B2C.THEMES[TEMPLATE_TYPES.B2C_ACORIS].UPSELLS]: Upsells,
  [TEMPLATES.B2C.THEMES[TEMPLATE_TYPES.B2C_ACORIS].PACKS]: Packs,
  [TEMPLATES.B2C.THEMES[TEMPLATE_TYPES.B2C_ACORIS].SUBSCRIPTION_DONE]:
    SubscriptionDone,
  default: Default,
};
export default Templates;
